import * as type from './constant';

const initialState = {
  dataAgencyConfig: null,

  updatedAgencyConfig: null,
  addedAgencyConfig: null,
  deletedAgencyConfig: null,

  loading: false,
  loadingManipulation: false,
  error: null,
  errorManipulation: null,
};
export default (state = initialState, action) => {

  switch (action.type) {

    case type.GET:
      return {
        ...state,
        updatedAgencyConfig: null,
        addedAgencyConfig: null,
        deletedAgencyConfig: null,
        loading: true,
        loadingManipulation: false,
        error: null,
        errorManipulation: null,
      };

    case type.GET_SUCCESS:
      return {
        ...state,
        [`dataAgencyConfig${action.agencyId}`]: {...action.payload},
        loading: false,
      };

    case type.GET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case type.UPDATE:
      return {
        ...state,
        updatedAgencyConfig: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.UPDATE_SUCCESS:
      return {
        ...state,
        updatedAgencyConfig: action.payload,
        loadingManipulation: false,
        [`dataAgencyConfig${action.agencyId}`]: {...action.payload},
      };

    case type.DELETE:
      return {
        ...state,
        deletedAgencyConfig: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.DELETE_SUCCESS:
      return {
        ...state,
        deletedAgencyConfig: action.payload,
        loadingManipulation: false,
      };

    case type.MANIPULATION_ERROR:
      return {
        ...state,
        loadingManipulation: false,
        errorManipulation: action.error,
      };

    default:
      return state;
  }
};
